export const tomos = [
  {
    number: 1,
    title: 'Fuerza Base & Estabilidad',
    sessions: '61 sesiones',
    months: 'Meses 1 y 2',
    desc: 'Para construir cimientos sólidos y fuerza estructural en tus alumnos desde el primer día.',
    details: [
      'Patrones básicos: sentadilla, bisagra, empuje, tracción y core',
      'Progresiones técnicas semana a semana para corregir la postura',
      'Ideal para arrancar el año o recibir alumnos nuevos',
    ],
    bar: 'bg-orange-500',
    text: 'text-orange-400',
    border: 'border-t-orange-500',
  },
  {
    number: 2,
    title: 'Potencia & Transferencia Funcional',
    sessions: '61 sesiones',
    months: 'Meses 3 y 4',
    desc: 'Para desarrollar velocidad, explosividad y transferencia directa a gestos deportivos.',
    details: [
      'Saltos, lanzamientos y pliometría segura por niveles',
      'Complejos fuerza-potencia con kettlebells y balón medicinal',
      'Transferencia a gestos deportivos y de la vida diaria',
    ],
    bar: 'bg-blue-500',
    text: 'text-blue-400',
    border: 'border-t-blue-500',
  },
  {
    number: 3,
    title: 'Resistencia Metabólica & Fat Loss',
    sessions: '61 sesiones',
    months: 'Meses 5 y 6',
    desc: 'Para quemar grasa y llevar el acondicionamiento metabólico de tu grupo al límite.',
    details: [
      'Formatos EMOM, AMRAP, Tabata e intervalos ya programados',
      'Intensidad controlada con versiones A/B/C para cada nivel',
      'Clases de alta quema con pausas y tiempos definidos',
    ],
    bar: 'bg-red-500',
    text: 'text-red-400',
    border: 'border-t-red-500',
  },
  {
    number: 4,
    title: 'Hipertrofia Funcional',
    sessions: '61 sesiones',
    months: 'Meses 7 y 8',
    desc: 'Para ganar masa muscular de forma funcional con protocolos de hipertrofia adaptados.',
    details: [
      'Bloques de volumen y tensión con equipamiento básico',
      'Superseries y tempos pensados para clases grupales',
      'Equilibrio entre estética, fuerza y rendimiento',
    ],
    bar: 'bg-violet-500',
    text: 'text-violet-400',
    border: 'border-t-violet-500',
  },
  {
    number: 5,
    title: 'Agilidad & Rendimiento Atlético',
    sessions: '61 sesiones',
    months: 'Meses 9 y 10',
    desc: 'Para mejorar la coordinación, agilidad y capacidad atlética general en cualquier nivel.',
    details: [
      'Escaleras, conos, cambios de dirección y reacción',
      'Coordinación y equilibrio con progresión gradual',
      'Juegos y desafíos que mantienen motivado al grupo',
    ],
    bar: 'bg-emerald-500',
    text: 'text-emerald-400',
    border: 'border-t-emerald-500',
  },
  {
    number: 6,
    title: 'Especialización & Desafíos Finales',
    sessions: '60 sesiones',
    months: 'Meses 11 y 12',
    desc: 'Para poner a prueba todo lo aprendido en el año con desafíos y benchmarks competitivos.',
    details: [
      'Benchmarks para medir el progreso de tus alumnos',
      'Desafíos por equipos y entrenamientos de cierre de año',
      'Evaluaciones para comparar el inicio con el final',
    ],
    bar: 'bg-amber-500',
    text: 'text-amber-400',
    border: 'border-t-amber-500',
  },
]

export const sessionFeatures = [
  { title: 'Objetivo del día', desc: 'Para que sepas exactamente hacia dónde vas' },
  { title: 'Warm-up listo', desc: 'Sin improvisar calentar' },
  { title: '3 versiones: A/B/C', desc: 'Grupo mixto o grupos separados, funciona igual' },
  { title: 'Series, reps y tiempos', desc: 'Especificados — nada ambiguo' },
  { title: 'Cool-down profesional', desc: 'Terminas cada clase con estructura' },
  { title: 'Tip del Coach', desc: 'Si eres principiante, aprendes. Si eres pro, validas' },
  { title: 'Una sesión por página', desc: 'Copiar-pegar, dictarla, listo' },
]

export const featureChips = [
  'Gym + Box + Funcional',
  'Programa anual listo',
  'Versiones A/B/C por nivel',
  'Warm-ups y cool downs',
  '365 sesiones listas',
  'Equipamiento básico',
]
